import { render } from "./DonatorBenefitsModal.vue?vue&type=template&id=6504e760"
const script = {}

import exportComponent from "/home/runner/work/web-frontend-dev/web-frontend-dev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__